import React from "react"

import Carousel from 'react-bootstrap/Carousel'
import styles from './carousel.module.css'

import {buildImageObj} from '../lib/helpers'
import {imageUrlFor} from '../lib/image-url'

const CarouselC = ({ data }) => {
  return (
    <Carousel>
      {data.photos.map( data => (
          <Carousel.Item>
            <p className={styles.caption}>{data.caption}</p>
            <img
              className="d-block w-100"
              src={imageUrlFor(buildImageObj(data))
                .width(1920)
                .height(Math.floor((9 / 16) * 1920))
                .fit('crop')
                .auto('format')
                .url()}
              alt={data.alt}
            />
          </Carousel.Item>
      ))
      }
    </Carousel>
  )
}

export default CarouselC